import type { IFeedCard } from "src/components/feed-card/types/feed-card";

export const getPinnedAndUnpinnedFeed = (feed: IFeedCard[] | null, pinnedCommentId: string | null) => {
    if (!feed) {
        return { pinnedCard: null, unpinnedFeed: null };
    }

    const pinnedCard = pinnedCommentId ? feed.find(card => card.id === pinnedCommentId) ?? null : null;
    const unpinnedFeed = pinnedCard ? feed.filter(card => card.id !== pinnedCard.id) : feed;

    return { pinnedCard, unpinnedFeed };
};
